export default (paramValue, paramName) => {
    let urlObj = new URL(window.location.href)
    let searchParams = new URLSearchParams(urlObj.search)

    if (searchParams.get(paramName) !== paramValue) {
        searchParams.delete(paramName)

        // Adding parameter in url
        searchParams.append(paramName, paramValue)
        urlObj.search = searchParams.toString()
        history.replaceState(null, null, urlObj.toString())
    }
}